import router from "sky-engine/router";

const component = {
  render(h) {
    return h("router-view");
  },
};

/**
 * noAuth:true                    不受权限控制的
 * parentPath:'/app'              父级路由
 * hidden: true                   如果hidden:true ，在左侧菜单中不展示此项，非必须，模式是显示
 * redirect: noredirect           如果 `redirect:noredirect` 在面包屑导航中，不会高亮此项且不具备路由功能，非必须
 * name:'router-name'             <keep-alive>需要此配置，必须有 而且是唯一的
 * meta : {
    role: ['admin','editor']     权限控制，可以配置多个，如果什么都没有配，默认所有角色都可见的
    title: 'title'               在菜单,面包屑显示的名称
    icon: 'svg-name'             在菜单中显示的svg图标
    noCache: true                页面是否需要缓存，默认是false
  }
 **/
/** 不需要权限控制的菜单 */

export const APP_PATH = "/app";

export const constantMenuRouterMap = [
  {
    path: "/guide",
    component: () => import("@/views/guide/index.vue"),
    name: "guide",
    meta: {
      title: "guide",
      icon: "home",
      noCache: true,
    },
  },
];

export const constantRouterMap = [
  {
    path: "*",
    name: "*",
    redirect: "/app",
    noAuth: true,
    hidden: true,
  },
  {
    path: "/login",
    component: () => import("@/views/login/index.vue"),
    hidden: true,
    name: "login",
  },
  {
    path: "/register",
    component: () => import("@/views/register/index.vue"),
    hidden: true,
    name: "register",
  },
  {
    path: "/wspToolFeishuLogin",
    component: () => import("@/views/wspToolFeishuLogin/index.vue"),
    hidden: true,
    noAuth: true,
    name: "wspToolFeishuLogin",
  },
  {
    path: "/wspSidLogin",
    component: () => import("@/views/wspSidLogin/index.vue"),
    hidden: true,
    noAuth: true,
    name: "wspSidLogin",
  },
  {
    path: "/npsCollection",
    component: () => import("@/views/npsCollection/index.vue"),
    hidden: true,
    noAuth: true,
    name: "npsCollection",
  },
  {
    path: "/",
    redirect: "app",
  },
  {
    path: "/app",
    component: () => import("../views/layout"),
    redirect: "guide",
    children: constantMenuRouterMap,
  },
];

export const channelNoAproRouter = [];

router.addRoutes(constantRouterMap);

/** 需要权限控制的菜单*/
export const asyncMenuRouterMap = [
  {
    path: "/gotoAction",
    parentPath: APP_PATH,
    component: () => import("@/views/login/gotoAction.vue"),
    hidden: true,
    name: "gotoAction",
  },
  {
    path: "/toAction",
    parentPath: APP_PATH,
    component: () => import("@/views/login/gotoAction.vue"),
    hidden: true,
    name: "toAction",
  },
  // {
  //   path: '/showView',
  //   component: () => import('@/views/dashboard/index.vue'),
  //   name: 'dashboard',
  //   meta: {
  //     title: 'dashboard',
  //     icon: 'overview',
  //     noCache: true
  //   }
  // },
  {
    path: "/poc",
    parentPath: APP_PATH,
    component: component,
    name: "poc",
    meta: {
      title: "poc",
      icon: "overview",
      noCache: true,
    },
    children: [
      {
        path: "/help",
        component: () => import("@/views/help/index.vue"),
        name: "help",
        meta: {
          title: "helpPoc",
          icon: "search",
          noCache: true,
        },
      },
      {
        path: "/pocMng",
        component: () => import("sky-engine/views/ViewManager"),
        name: "pocMng",
        meta: {
          title: "pocMng",
          icon: "home",
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/delivery",
    parentPath: APP_PATH,
    component: component,
    name: "deliveryDeploy",
    meta: {
      title: "deliveryDeploy",
      icon: "overview",
      noCache: true,
    },
    children: [
      {
        path: "/deliveryDeployMng",
        component: () => import("sky-engine/views/ViewManager"),
        name: "deliveryDeployMng",
        meta: {
          title: "deliveryDeployMng",
          icon: "home",
          noCache: true,
        },
      },
      {
        path: "/toBeDeliveryDeploy",
        component: () => import("sky-engine/views/ViewManager"),
        name: "toBeDeliveryDeployMng",
        meta: {
          title: "toBeDeliveryMng",
          icon: "home",
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/sharedMng",
    component: component,
    parentPath: APP_PATH,
    name: "sharedMng",
    meta: {
      title: "sharedMng",
      icon: "share",
      noCache: true,
    },
    children: [
      {
        path: "/compatibleMng",
        component: () => import("sky-engine/views/ViewManager"),
        name: "compatibleMng",
        meta: {
          title: "compatibleMng",
          icon: "send",
          noCache: true,
        },
        children: [
          {
            path: "/software",
            component: () => import("sky-engine/views/ViewManager"),
            name: "compatibleSoftwareMng",
            meta: {
              title: "compatibleSoftwareMng",
              icon: "share",
              noCache: true,
            },
          },
          {
            path: "/peripheral",
            component: () => import("sky-engine/views/ViewManager"),
            name: "compatiblePeripheralMng",
            meta: {
              title: "compatiblePeripheralMng",
              icon: "home",
              noCache: true,
            },
          },
          {
            path: "/reportMng",
            component: () => import("sky-engine/views/ViewManager"),
            name: "reportMng",
            meta: {
              title: "reportMng",
              icon: "send",
              noCache: true,
            },
          },
          {
            path: "/reportQryMng",
            component: () => import("sky-engine/views/ViewManager"),
            name: "reportQryMng",
            meta: {
              title: "reportQryMng",
              icon: "send",
              noCache: true,
            },
          },
        ],
      },
      {
        path: "/caseRepo",
        component: () => import("sky-engine/views/ViewManager"),
        name: "caseRepo",
        meta: {
          title: "caseRepo",
          icon: "table",
          noCache: true,
        },
      },
      {
        path: "/featureLimit",
        component: () => import("sky-engine/views/ViewManager"),
        name: "featureLimitMng",
        meta: {
          title: "featureLimit",
          icon: "maintain",
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/onlineTool",
    component: component,
    parentPath: APP_PATH,
    name: "onlineTool",
    meta: {
      title: "onlineTool",
      icon: "el-icon-goods",
      noCache: true,
    },
    children: [
      /* {
        path: '/serverCalculator',
        component: () => import('sky-engine/views/ViewManager'),
        name: 'serverCalculatorMng',
        meta: {
          title: 'serverCalculator',
          icon: 'el-icon-tickets',
          noCache: true
        }
      }, */
      {
        path: "/serverCalculatorOnline",
        parentPath: APP_PATH,
        component: () => import("@/views/calculatorOnlineController/index.vue"),
        name: "calculatorOnlineMng",
        meta: {
          title: "serverCalculator",
          icon: "share",
          noCache: true,
        },
      },
    ],
  },
  /**
   * 原厂服务菜单
   * 权限控制：由后端 menuNameArr 决定可见性，仅原厂角色可见。
   * 后端需将 'manufacturerService' 与 'vdiProductSelector' 配置到原厂角色的菜单权限中。
   */
  {
    path: "/manufacturerService",
    component: component,
    parentPath: APP_PATH,
    name: "manufacturerService",
    meta: {
      title: "manufacturerService",
      icon: "el-icon-goods",
      noCache: true,
    },
    children: [
      {
        path: "/vdiProductSelector",
        parentPath: APP_PATH,
        component: () =>
          import("@/views/manufacturerService/vdiProductSelector/index.vue"),
        name: "vdiProductSelector",
        meta: {
          title: "vdiProductSelector",
          icon: "el-icon-tickets",
          noCache: true,
        },
      },
      {
        path: "/servicePriceAudit",
        parentPath: APP_PATH,
        component: () =>
          import("@/views/manufacturerService/servicePriceAudit/index.vue"),
        name: "servicePriceAudit",
        meta: {
          title: "servicePriceAudit",
          icon: "el-icon-document",
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/tool",
    parentPath: APP_PATH,
    component: () => import("@/views/toolController/index.vue"),
    name: "tool",
    meta: {
      title: "tool",
      icon: "tools",
      noCache: true,
    },
  },
  {
    path: "/cloudDeskTopOtherSystem",
    parentPath: APP_PATH,
    component: () =>
      import("@/views/cloudDeskTopOtherSystemController/index.vue"),
    name: "cloudDeskTopOtherSystem",
    meta: {
      title: "cloudDeskTopOtherSystem",
      icon: "share",
      noCache: true,
    },
  },
  {
    path: "/feedbackCollectMng",
    parentPath: APP_PATH,
    component: () => import("sky-engine/views/ViewManager"),
    name: "feedbackCollectMng",
    meta: {
      title: "feedbackCollectMng",
      icon: "share",
      noCache: true,
    },
  },
  {
    path: "/projectSetting",
    component: component,
    parentPath: APP_PATH,
    control: true,
    hidden: false,
    name: "projectSetting",
    meta: {
      title: "projectSetting",
      icon: "setting",
      noCache: true,
    },
    children: [
      {
        path: "/industry",
        component: () => import("sky-engine/views/ViewManager"),
        name: "industryMng",
        meta: {
          title: "industryMng",
          icon: "image",
          noCache: true,
        },
      },
      {
        path: "/featureMng",
        component: () => import("sky-engine/views/ViewManager"),
        name: "featureMng",
        meta: {
          title: "featureMng",
          icon: "maintain",
          noCache: true,
        },
        children: [
          {
            path: "/feature",
            component: () => import("sky-engine/views/ViewManager"),
            name: "feature",
            meta: {
              title: "featureMng",
              icon: "maintain",
              noCache: true,
            },
          },
          {
            path: "/featureValueMng",
            component: () => import("sky-engine/views/ViewManager"),
            name: "featureValueMng",
            meta: {
              title: "featureValueMng",
              icon: "maintain",
              noCache: true,
            },
          },
        ],
      },
      {
        path: "/case",
        component: () => import("sky-engine/views/ViewManager"),
        name: "caseMng",
        meta: {
          title: "caseMng",
          icon: "table",
          noCache: true,
        },
        children: [
          {
            path: "/caseSoftware",
            component: () => import("sky-engine/views/ViewManager"),
            name: "caseSoftwareMng",
            meta: {
              title: "caseSoftwareMng",
              icon: "share",
              noCache: true,
            },
          },
          {
            path: "/casePeripheral",
            component: () => import("sky-engine/views/ViewManager"),
            name: "casePeripheralMng",
            meta: {
              title: "casePeripheralMng",
              icon: "driving",
              noCache: true,
            },
          },
          {
            path: "/caseBusi",
            component: () => import("sky-engine/views/ViewManager"),
            name: "caseBusiMng",
            meta: {
              title: "caseBusiMng",
              icon: "remote",
              noCache: true,
            },
          },
        ],
      },
      {
        path: "/software",
        component: () => import("sky-engine/views/ViewManager"),
        name: "softwareMng",
        meta: {
          title: "softwareMng",
          icon: "share",
          noCache: true,
        },
      },
      {
        path: "/peripheral",
        component: () => import("sky-engine/views/ViewManager"),
        name: "peripheralMng",
        meta: {
          title: "peripheralMng",
          icon: "home",
          noCache: true,
        },
      },
      {
        path: "/software/black",
        component: () => import("sky-engine/views/ViewManager"),
        name: "softwareBlackListMng",
        meta: {
          title: "softwareBlackListMng",
          icon: "share",
          noCache: true,
        },
      },
      {
        path: "/server",
        component: () => import("sky-engine/views/ViewManager"),
        name: "serverMng",
        meta: {
          title: "serverMng",
          icon: "server",
          noCache: true,
        },
      },
      {
        path: "/terminal",
        component: () => import("sky-engine/views/ViewManager"),
        name: "terminalMng",
        meta: {
          title: "terminalMng",
          icon: "terminal",
          noCache: true,
        },
      },
      {
        path: "/toolMng",
        component: () => import("sky-engine/views/ViewManager"),
        name: "toolMng",
        meta: {
          title: "toolMng",
          icon: "tools",
          noCache: true,
        },
      },
      {
        path: "/deliveryDeployConfig",
        component: () => import("sky-engine/views/ViewManager"),
        name: "deliveryDeployConfig",
        meta: {
          title: "deliveryDeployConfig",
          icon: "table",
          noCache: true,
        },
        children: [
          {
            path: "/deliveryGuideMng",
            component: () => import("sky-engine/views/ViewManager"),
            name: "deliveryGuideMng",
            meta: {
              title: "deliveryGuideMng",
              icon: "tools",
              noCache: true,
            },
          },
          {
            path: "/position",
            component: () => import("sky-engine/views/ViewManager"),
            name: "positionMng",
            meta: {
              title: "positionMng",
              icon: "image",
              noCache: true,
            },
          },
        ],
      },
      {
        path: "/productConfig",
        component: () => import("sky-engine/views/ViewManager"),
        name: "productConfig",
        meta: {
          title: "productConfig",
          icon: "table",
          noCache: true,
        },
        children: [
          {
            path: "/product",
            component: () => import("sky-engine/views/ViewManager"),
            name: "productMng",
            meta: {
              title: "productMng",
              icon: "rank",
              noCache: true,
            },
          },
          {
            path: "/productStrategyMng",
            component: () => import("sky-engine/views/ViewManager"),
            name: "productStrategyMng",
            meta: {
              title: "productStrategyMng",
              icon: "el-icon-news",
              noCache: true,
            },
          },
        ],
      },
      {
        path: "/maintenanceMng",
        component: () => import("sky-engine/views/ViewManager"),
        name: "maintenanceMng",
        meta: {
          title: "maintenanceMng",
          icon: "table",
          noCache: true,
        },
        children: [
          {
            path: "/copyScene",
            component: () => import("sky-engine/views/ViewManager"),
            name: "copyScene",
            meta: {
              title: "copyScene",
              icon: "el-icon-news",
              noCache: true,
            },
          },
          {
            path: "/batchMaintenance",
            component: () => import("sky-engine/views/ViewManager"),
            name: "batchMaintenance",
            meta: {
              title: "batchMaintenance",
              icon: "transport",
              noCache: true,
            },
          },
          {
            path: "/copyFeatureAndTestCaseMng",
            component: () => import("sky-engine/views/ViewManager"),
            name: "copyFeatureAndTestCaseMng",
            meta: {
              title: "copyFeatureAndTestCaseMng",
              icon: "el-icon-news",
              noCache: true,
            },
          },
        ],
      },
      {
        path: "/osType",
        component: () => import("sky-engine/views/ViewManager"),
        name: "osTypeMng",
        meta: {
          title: "osTypeMng",
          icon: "win10",
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/serverCalSetting",
    component: component,
    parentPath: APP_PATH,
    name: "serverCalSetting",
    control: true,
    hidden: false,
    meta: {
      title: "serverCalSetting",
      icon: "el-icon-setting",
      noCache: true,
    },
    children: [
      {
        path: "/calSoftware",
        component: () => import("sky-engine/views/ViewManager"),
        name: "calSoftwareMng",
        meta: {
          title: "calSoftwareMng",
          icon: "share",
          noCache: true,
        },
      },
      {
        path: "/gpuCard",
        component: () => import("sky-engine/views/ViewManager"),
        name: "gpuCardMng",
        meta: {
          title: "gpuCardMng",
          icon: "el-icon-mobile-phone",
          noCache: true,
        },
      },
      {
        path: "/desktopElementMng",
        component: () => import("sky-engine/views/ViewManager"),
        name: "desktopElementMng",
        meta: {
          title: "desktopElementMng",
          icon: "el-icon-document",
          noCache: true,
        },
      },
      {
        path: "/segmentSceneMng",
        component: () => import("sky-engine/views/ViewManager"),
        name: "segmentSceneMng",
        meta: {
          title: "segmentSceneMng",
          icon: "el-icon-news",
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/systemSetting",
    parentPath: APP_PATH,
    component: component,
    name: "systemSetting",
    control: true,
    hidden: false,
    meta: {
      title: "systemSetting",
      icon: "share",
      noCache: true,
    },
    children: [
      {
        path: "/systemSet",
        component: () => import("sky-engine/views/ViewManager"),
        name: "systemSettingMng",
        meta: {
          title: "systemSettingMng",
          icon: "maintain",
          noCache: true,
        },
      },
      {
        path: "/npsUpdate",
        component: () => import("sky-engine/views/ViewManager"),
        name: "npsMng",
        meta: {
          title: "npsMng",
          icon: "maintain",
          noCache: true,
        },
      },
      {
        path: "/feedbackMng",
        component: () => import("sky-engine/views/ViewManager"),
        name: "feedbackMng",
        meta: {
          title: "feedbackMng",
          icon: "share",
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/userMng",
    parentPath: APP_PATH,
    component: component,
    name: "userMng",
    control: true,
    hidden: false,
    meta: {
      title: "userMng",
      icon: "user",
      noCache: true,
    },
    children: [
      {
        path: "/channel",
        component: () => import("sky-engine/views/ViewManager"),
        name: "channelMng",
        meta: {
          title: "channelMng",
          icon: "share",
          noCache: true,
        },
      },
      {
        path: "/userInfo",
        hidden: true,
        component: () => import("@/views/login/userInfo.vue"),
        name: "userInfo",
        meta: {
          title: "userInfo",
          icon: "share",
          noCache: true,
        },
      },
      {
        path: "/areaIndustryUser",
        component: () => import("sky-engine/views/ViewManager"),
        name: "areaIndustryUserMng",
        meta: {
          title: "areaIndustryUserMng",
          icon: "share",
          noCache: true,
        },
      },
    ],
  },
  {
    path: "/userMng",
    component: component,
    parentPath: APP_PATH,
    name: "readyUserMng",
    meta: {
      title: "userMng",
      icon: "user",
      noCache: true,
    },
    children: [
      {
        path: "/userInfo",
        component: () => import("@/views/login/userInfo.vue"),
        name: "baseUserInfo",
        meta: {
          title: "userInfo",
          icon: "share",
          noCache: true,
        },
      },
    ],
  },
];
